<script lang="ts">
    import { Button, DatePicker, DatePickerInput, FileUploader, Form, FormGroup, Select, SelectItem, TextArea, TextInput } from "carbon-components-svelte";
    import type { Repository } from "../libraries/repository";
    import { Indemnity } from "../model/indemnity";
    import { IndemnityStatus } from "../model/indemnityStatus";
    import { DocumentType } from "../model/type";
    import { Utils } from "../utils/utils";
    import NotificationInline from "./NotificationInline.svelte";

    export let repository: Repository;
    let newIndemnity: Indemnity = new Indemnity();
    let errorMessage = "";
    let fileToUpload;
    let since: string;
    let until: string;
    $: invalidType = false;
    $: invalidStatus = false;
    $: invalidClient = false;
    $: showSuccess = false;
    $: showError = false;

    async function createNewIndemnity(){
        if(!invalidType && !invalidStatus && !invalidClient){
            if(since != ""){
                newIndemnity.since = Utils.formatDate(since);
            }else{
                newIndemnity.since = null;
            }
            if(until != ""){
                newIndemnity.until = Utils.formatDate(until);
            }else{
                newIndemnity.until = null;
            }
            let createIndemnityResponse = await repository.createIndemnity(newIndemnity);
            if(createIndemnityResponse.success){
                let createdIndemnity = createIndemnityResponse.data;
                uploadFile(createdIndemnity);
            }else{
                errorMessage = Utils.errorMessage(createIndemnityResponse);
                showError = true;
            }
        }else{
            errorMessage = "Compilare correttamente il form."
            showError = true;
        }
    }

    async function uploadFile(createdIndemnity:Indemnity){
    if((fileToUpload != null || fileToUpload != undefined) && fileToUpload.length > 0){
        let response = await repository.uploadIndemnity(fileToUpload[0], createdIndemnity.uuid);
        if(response.success){
            showSuccess = true;
        }else{
            deleteIndemnity(createdIndemnity.uuid);
            errorMessage = Utils.errorMessage(response);
            showError = true;
        }
    }else{
        deleteIndemnity(createdIndemnity.uuid);
        errorMessage="Il file non è stato caricato correttamente."
        showError = true;
    }

    async function deleteIndemnity(indemnityUuid: string){
        let response = await repository.deleteIndemnity(indemnityUuid);
        console.log("delete indemnity response success: ", response.success);
    }
}

</script>

<h2 class="mb-1">Nuova manleva</h2>
<Form on:submit={(e) => {e.preventDefault(); createNewIndemnity();}}>
    <FormGroup>
        <TextArea labelText="Descrizione" bind:value={newIndemnity.description} />
        <TextArea labelText="Note" bind:value={newIndemnity.notes} />
        <Select 
            required 
            labelText="Tipologia di documento" 
            invalid = {invalidType}
            invalidText="Questo campo è obbligatorio: selezionare un'opzione."
            on:change={(e) => newIndemnity.type = DocumentType[e.detail]}>
            <SelectItem value="" />
            {#each Object.keys(DocumentType) as key}
                <SelectItem value={DocumentType[key]}></SelectItem>
            {/each}
        </Select>
        <TextInput labelText="Cliente" bind:value={newIndemnity.client} required invalid={invalidClient} invalidText="Questo campo è obbligatorio." />
        <TextInput labelText="NAS id" bind:value={newIndemnity.nasid} />
        <DatePicker datePickerType="single" bind:value={since} dateFormat="d/m/Y" >
            <DatePickerInput labelText="Data d'inizio" />
        </DatePicker>
        <DatePicker datePickerType="single" bind:value={until} dateFormat="d/m/Y" >
            <DatePickerInput labelText="Data di fine" />
        </DatePicker>
        <Select 
            required 
            labelText="Stato del documento" 
            invalid = {invalidStatus}
            invalidText="Questo campo è obbligatorio: selezionare un'opzione."
            on:change={(e) => newIndemnity.indemnityStatus = IndemnityStatus[e.detail]}>
            <SelectItem value="" />
            <SelectItem value={IndemnityStatus.DRAFT} />
            <SelectItem value={IndemnityStatus.PUBLISHED} />
        </Select>
        <FileUploader
            on:add={(e) => {fileToUpload = e.detail;}}
            name="fileToUpload"
            kind="tertiary"
            buttonLabel="Carica file"
            status="edit" />
        <div class="base-flex" style="align-items: center !important">
            <Button type="submit">Salva</Button>
            {#if showError}
            <NotificationInline title="Errore" subtitle={errorMessage} kind="error" onClose={() => { showError = false; errorMessage = ""; }} />
            {/if}
            {#if showSuccess}
            <NotificationInline title="" subtitle="Manleva creata correttamente." kind="success" onClose={() => { showSuccess = false; errorMessage = ""; }} />
            {/if}
        </div>
    </FormGroup>
</Form>
